import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";

interface Props {
  label: string;
  data: string;
  url: string;
  subdata: string;
  dataMaxWidthPx?: number;
}

export const CustomLabeledData = ({ label, data, url, subdata, dataMaxWidthPx }: Props) => {
  const dataStyle = dataMaxWidthPx
    ? {
        maxWidth: `${dataMaxWidthPx}px`,
        wordBreak: "break-word" as const,
        whiteSpace: "normal" as const,
      }
    : undefined;
  return (
    <Flex gap={20}>
      <div>
        <Text css={{ minWidth: "192px", maxWidth: "192px" }} variant="secondary-md">
          {label}
        </Text>
      </div>
      <Flex justifyContent="flex-start" flexDirection="column" gap={4}>
        {url ? (
          <a
            style={{ color: Colors.Primary600, fontSize: "14px" }}
            id={`${label}-link`}
            target="_blank"
            rel="noreferrer"
            href={url}
          >
            {data} <Icon type="external-link" color={Colors.Primary600} />
          </a>
        ) : (
          <Text variant="secondary-md" id={`${label}-text`} css={dataStyle}>
            {data}
          </Text>
        )}
        <Text variant="secondary-sm"> {subdata}</Text>
      </Flex>
    </Flex>
  );
};
